import React from "react";

import { Layouter } from "./layouter";
import { useMediaQuery } from "react-responsive";
import { MpaIcon } from "../icon";

const Layout = props => {
  const { socket, data } = props;
  const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 1024 });

  return (
    /* Organize the divs in a manner consistent with the classes defined in the stylesheet */

    /* The data field has a rows object which contains all the necessary UI layout information */
    <div className="screen-parent">
      <div className="tb">
        <div className="tbm">{data.title}</div>
        <div className="tbr">
          {isTablet && <MpaIcon style={{ fontSize: 60 }} />}
          {!isTablet && <MpaIcon style={{ fontSize: 40 }} />}
        </div>
      </div>
      <Layouter widgetRows={data.rows} socket={socket}></Layouter>
    </div>
  );
};

export default Layout;
